import { STEPS } from "@/lib/siteContent";

export const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="py-24 sm:py-32 border-t border-[#E5E7EB] bg-[#0F2A44] text-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16 lg:mb-20">
          <p className="text-xs uppercase tracking-[0.25em] text-[#D4AF7F] mb-6">
            How it works
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl tracking-tight leading-tight">
            Three steps from
            <span className="italic"> packet to paycheck.</span>
          </h2>
        </div>

        <ol className="grid grid-cols-1 md:grid-cols-3 gap-0">
          {STEPS.map((step, i) => (
            <li
              key={step.number}
              data-testid="how-step"
              className={`py-10 md:py-0 md:px-10 lg:px-12 border-t border-white/15
                ${i < STEPS.length - 1 ? "md:border-r" : ""}
                md:border-t-0
                ${i === 0 ? "md:pl-0" : ""}
                ${i === STEPS.length - 1 ? "md:pr-0" : ""}
              `}
            >
              <div className="flex items-baseline gap-4 mb-6">
                <span className="font-serif text-5xl text-[#D4AF7F] leading-none">
                  {step.number}
                </span>
                <span className="h-px flex-1 bg-white/20" />
              </div>
              <h3 className="font-serif text-2xl mb-4">{step.title}</h3>
              <p className="text-white/70 leading-relaxed">{step.description}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
